( function() {
    "use strict";

    angular
        .module( 'ccsTrApp' )
        .service( 'InvoicePaymentCustomService', InvoicePaymentCustomService );

    InvoicePaymentCustomService.$inject = ['$http'];

    function InvoicePaymentCustomService( $http ) {
        var service = {
            returnInvoicePaymentsByInvoice: returnInvoicePaymentsByInvoice,
            getMinifiedInvoicePaymentsForInvoiceDetailByInvoice: getMinifiedInvoicePaymentsForInvoiceDetailByInvoice
        };

        return service;

        function returnInvoicePaymentsByInvoice( id ) {
            var url = "api/invoice-payments/invoice/" + id;
            return $http.get( url );
        }

        function getMinifiedInvoicePaymentsForInvoiceDetailByInvoice(id) {
            var url = "api/invoice-payments/minified/invoice/" + id;
            return $http.get(url);
        }
    }

})();
